// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Own Components
import { ChipsComponent } from 'libraries/module/formbuilder/fields/chips/chips.component';
import { FormFieldModule } from '../form-field/form-field.module';
import { ChipsInputComponent } from './chipsInput.component';
import { AfidiumChipInputDirective } from './afidiumChipInput.directive';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormFieldModule,
        MatChipsModule,
        MatIconModule,
        MatFormFieldModule,
        NotificationModule,
        MatAutocompleteModule,
        FontAwesomeModule,
    ],
    declarations: [
        ChipsComponent,
        ChipsInputComponent,
        AfidiumChipInputDirective
    ],
    exports: [
        ChipsComponent,
        ChipsInputComponent,
    ]
})

export class ChipsModule { }
